<script>
import { ref } from '@vue/reactivity';
import { computed } from '@vue/runtime-core';
export default {
  name: 'MainBoard',
  props: {
    msg: String
  },
  setup () {
    const turn = ref('X');
    const squares = ref([]);
    squares.value = Array(9).fill('');
    // test of setup
    const appName = "TICTAKTOE";
    console.log(appName.toLowerCase().slice(0, 6));
    //
    const winner = computed(() => winnerCheck(squares.value.flat())); //check for winner 
    function winnerCheck(value) {
      console.log("inside winnderCheck value: " + value);
      const lines = [
        [0,1,2],
        [3,4,5],
        [6,7,8], //horizontal wins
        [0,3,6],
        [1,4,7],
        [2,5,8], //vertical wins
        [0,4,8],
        [2,4,6] //cross wins
      ];
      for (let i = 0; i < lines.length; i++){
        const[a,b,c] = lines [i]
        if(
          value[a] &&
          value[a] === value[b] && 
          value[a] === value[c]
          ){
          return value[a]
        }
      }
      return null
    }
    function nextIn(i) {
      console.log("index number: " + i)
      if (winner.value){
        console.log("inside if winner value: " + winner.value)
        return 
      }
      // current player takes a turn, value is assigned to a board position
      squares.value[i] = turn.value
      // 
      turn.value = turn.value === 'X' ? '0' : 'X'
      console.log("player: " + turn.value);
    }
    function reset() {
      console.log("reset!!");
      squares.value = Array(9).fill('');
    }
    return { squares, nextIn, winner, turn, reset } 
  } 
}
</script>

<template>
<h2> {{ msg }} </h2>
<h2 v-if="winner" >The winner is: {{ winner }} </h2>
<h2 v-else>Player {{ turn }} move</h2>
<button class="reset" @click="reset">  
Reset
</button>
<div id="board">
  <div id="square" v-for="(square, index) in squares" :key="index" @click="nextIn(index)">
    {{ square }}   
  </div>
</div>

</template>



<style scoped>

* {
  background-color: rgb(14, 11, 39);
}

#board{
  height: 360px;
  width: 360px;
  background-color: none;
  margin: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 10%;
  /* border: 1px solid rgb(0, 135, 180); */
}

#square {
  border: 0.2px solid rgb(0, 135, 180); 
  height: 100px;
  width: 100px;
  font-size: 50px;
  vertical-align: middle;
  align-content: center;
  line-height: 200%;
  color: lightblue;
  margin: 8px;
  border-radius: 12px;
  box-shadow: 0px 1px 5px 1px rgb(0, 135, 180);
}
.square:hover {
  background-color: rgb(34, 27, 92);
  cursor: pointer;
  opacity: 0.8;
}
.reset {
  background-color: transparent;
  width: 90px;
  height: 35px;
  border: 2px solid rgb(0, 135, 180);
  margin: 20px;
  font-size: 25px;
  color: lightblue; 
  border-radius: 6px;
}
.reset:hover {
  background-color: rgb(34, 27, 92);
  cursor: pointer;
  opacity: 1;
  font-weight: bolder;
  box-shadow: 0px 1px 5px 1px rgb(0, 135, 180);
}
</style>
